import { render, staticRenderFns } from "./VenPL.vue?vue&type=template&id=af08b60e"
import script from "./VenPL.vue?vue&type=script&lang=js"
export * from "./VenPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports